export default __webpack_public_path__ + "static/media/spinner-gray.12e6aadc.svg";